import { API_BASE_URL, performTokenRefresh } from "@repo/api";
import type { HostConfig } from "./hostConfig";

export interface AgentRuntimeAuthzHostConfig extends HostConfig {}

const isDev = import.meta.env.DEV;

export function getAgentRuntimeAuthzHostConfig(
  onNavigate?: (path: string) => void,
): AgentRuntimeAuthzHostConfig {
  const apiBaseUrl = isDev
    ? `${window.location.origin}/api-proxy`
    : (import.meta.env.VITE_API_BASE_URL as string) || window.location.origin;

  return {
    basename: "/agent-runtime-authz",
    apiBaseUrl,
    onUnauthorized: () => performTokenRefresh(API_BASE_URL),
    onNavigate,
  };
}
